import type { BreadcrumbItem } from '@drivekyte/web-components';
import React from 'react';
import dynamic from 'next/dynamic';

const HeaderWithBreadcrumbs = dynamic(() =>
  import('./components/header-with-breadcrumbs'),
);
const HeaderWithSearch = dynamic(() =>
  import('./components/header-with-search'),
);
const HeaderWithoutSearch = dynamic(() =>
  import('./components/header-without-search'),
);

type HeaderProps = {
  children: React.ReactNode;
  defaultShowSearchInput: boolean;
  defaultShowSearchToggler: boolean;
  showSearchButton: boolean;
  setShowSearchButton: (value: boolean) => void;
  searchEnabled: boolean;
  subscriptionBreadcrumbs?: BreadcrumbItem[];
};

const Header = ({
  children,
  defaultShowSearchInput,
  defaultShowSearchToggler,
  showSearchButton,
  setShowSearchButton,
  searchEnabled,
  subscriptionBreadcrumbs,
}: HeaderProps) => {
  if (searchEnabled) {
    return (
      <HeaderWithSearch
        defaultShowSearchInput={defaultShowSearchInput}
        defaultShowSearchToggler={defaultShowSearchToggler}
        showSearchButton={showSearchButton}
        setShowSearchButton={setShowSearchButton}
      >
        {children}
      </HeaderWithSearch>
    );
  }

  if (subscriptionBreadcrumbs) {
    return (
      <HeaderWithBreadcrumbs breadcrumbsItems={subscriptionBreadcrumbs}>
        {children}
      </HeaderWithBreadcrumbs>
    );
  }

  return <HeaderWithoutSearch>{children}</HeaderWithoutSearch>;
};

export default Header;
